import { store } from '@/redux/store';
import { openedDrawerSelector } from '@/redux/drawer/drawer.selectors';
import { DrawerName } from '@/types/drawerName';

export const getOpenedPanel = (): DrawerName | undefined => {
  const { getState } = store;
  const drawerName = openedDrawerSelector(getState());

  return drawerName;
};
